export default __webpack_public_path__ + "static/media/Accueil_Deconnecté.64955bc7.png";